import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useGetProfileQuery } from 'redux/Api/profileApi/ProfileApi';
import { RootState } from 'redux/store';

const isWorksupportRole = () =>
  (localStorage.getItem('role') || '').toLowerCase() === 'worksupport';

export const useTabSync = () => {
  const isWorksupport = isWorksupportRole();
  const beneficiar = useSelector(
    (state: RootState) => state.beneficiarSlice.infoBeneficiar,
  );
  const token = localStorage.getItem('token');
  const showCompanySelect = localStorage.getItem('showCompanySelect');
  const isAuth = !!token && !showCompanySelect;
  const { data: profile } = useGetProfileQuery(undefined, {
    skip: !isAuth || isWorksupport,
  });
  const lastSyncRef = useRef<string>('');

  useEffect(() => {
    if (isWorksupport) return;

    if (beneficiar?.id || profile?.id) {
      const syncData = {
        beneficiarId: beneficiar?.id,
        customerId: profile?.id,
        beneficiarData: beneficiar,
        timestamp: Date.now(),
      };

      localStorage.setItem('appSync', JSON.stringify(syncData));
      lastSyncRef.current = JSON.stringify(syncData);
    }
  }, [beneficiar, profile, isWorksupport]);

  useEffect(() => {
    if (isWorksupport) return;

    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'appSync' && e.newValue !== e.oldValue) {
        try {
          const externalData = JSON.parse(e.newValue || '{}');
          const currentData = {
            beneficiarId: beneficiar?.id,
            customerId: profile?.id,
          };

          const hasBeneficiarChanged =
            externalData.beneficiarId &&
            externalData.beneficiarId !== currentData.beneficiarId;
          const hasCustomerChanged =
            externalData.customerId && externalData.customerId !== currentData.customerId;

          if (hasBeneficiarChanged || hasCustomerChanged) {
            window.location.reload();
          }
        } catch (error) {
          //
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [beneficiar?.id, profile?.id, isWorksupport]);
};
